

const BRAND_SUBMITTED_CONTENT = [
  '<p><strong>Your identity and text message registrations have been submitted and are being processed.</strong></p>',
  '<p>Check your registration approval status at any time under the <a href="/communications/text/text-management" target="_blank">Text Management</a> console in LionDesk.</p>',
  '<p>Registration processing and approval can take up to 2-3 weeks.</p>'
];

const BRAND_ERROR_CONTENT = [
  '<p><strong>Uh-oh – your identity verification was unsuccessful.</strong></p>',
  '<p>There was a technical error during the registration submission. We have been notified and are working on it.</p>',
  '<p>Check the <a href="/communications/text/text-management" target="_blank">Text Management</a> console for updates.</p>'
];

const BRAND_FAILED_CONTENT = [
  '<p><strong>Uh-oh – your identity verification was unsuccessful.</strong></p>',
  '<p>Please return to the identify verification form to fix the issues that were unsuccessful and try submitting again.</p>'
];

const BRAND_ERROR_3_TIMES_CONTENT = [
  '<p><strong>Unfortunately, your identity verification has failed three times.</strong></p>',
  '<p>There was a technical error during the registration submission. We have been notified and are working on it.</p>',
  '<p>Check the <a href="/communications/text/text-management" target="_blank">Text Management</a> console for updates.</p>'
];

const BRAND_FAILED_3_TIMES_CONTENT = [
  '<p><strong>Unfortunately, your identity verification has failed three times.</strong></p>',
  '<p>Please click the button below to send your registration report to Support so that they can assist you in successfully completing the registration process.</p>',
];

const CAMPAIGN_FAILED_3_TIMES_CONTENT = [
  '<p><strong>Unfortunately, your text message types verification has failed three times.</strong></p>',
  '<p>Please click the button below to send your registration report to Support so that they can assist you in successfully completing the registration process.</p>',
];


const BRAND_OTP_ERROR_CONTENT = [
  '<p><strong>Your identity has been accepted!.</strong>',
  '<p>There was a technical error during mobile verification. We have been notified and are working on it.</p>',
  '<p>Check the <a href="/communications/text/text-management" target="_blank">Text Management</a> console for updates.</p>'
];

const BRAND_ACCEPTED_OTP_PENDING_CONTENT = [
  '<p><strong>Your identity has been accepted!.</strong></p>',
  '<p>Now it’s time to confirm your mobile number</p>',
  '<p>You should receive a text message from The Campaign Registry @ 1 (915) 278-2000 asking you to confirm your mobile number. <br> <strong>Please reply “YES” within 24 hours</strong></p>',
  '<p><img style="display:block; margin:auto;" src="/static/img/campaign-registry.png" width="42%" /></p>',
  '<p>You will receive this notification text every 24 hours until you confirm. You can also resend the notification now by <a href="#">clicking this link</a> or the Resend button in the <a href="/communications/text/text-management" target="_blank">Text Management</a> console.</p>',
  '<p>If you accidentally replied “STOP” to the verification number, you will not receive any future verification requests and your registration may fail. If this happened, simply reply “START” to the verification number and you will receive the next automatic notification.</p>'
];

const BRAND_OTP_FAILED_CONTENT = [
  '<p>Unfortunately, you did not complete your mobile phone verification within 30 days. Your current registration has expired.</p>',
  '<p>You must restart your registration in order to use texting in LionDesk.</p>',
];

const BRAND_OTP_COMPLETED_CONTENT = [
  '<p><strong>Your identity and mobile phone have been verified!</strong></p>',
  '<p>We are still waiting for verification of your text message types. Registration processing and approval can take up to 2-3 weeks.</p>',
  '<p>Check your registration approval status at any time under the <a href="/communications/text/text-management" target="_blank">Text Management</a> console in LionDesk.</p>'
];

const CAMPAIGN_ERROR_CONTENT = [
  '<p><strong>Uh-oh - your text message type verification was unsuccessful.</strong>',
  '<p>There was a technical error during the registration submission. We have been notified and are working on it.</p>',
  '<p>Check the <a href="/communications/text/text-management" target="_blank">Text Management</a> console for updates.</p>'
];

const CAMPAIGN_FAILED_CONTENT = [
  '<p><strong>Uh-oh – your text message type verification was unsuccessful.</strong></p>',
  '<p>Please return to the text message form to fix the issues that were unsuccessful and try submitting again.</p>',
];

const CAMPAIGN_FAILED_BLOCKED_CONTENT = [
  '<p><strong>Your registration cannot be processed.</strong></p>',
  '<p>Your text message type was rejected due to a disalowed use case or content violation. Your registration is ineligible for resubmission.</p>',
];

const CAMPAIGN_COMPLETED_CONTENT = [
  '<p><strong>Congratulations! Your registration was successful!</strong></p>',
  '<p>You are now able to use the power of texting in LionDesk for 1-to-1 communications and Text2Sell!</p>',
  `<p>To safeguard your custom number's reputation with carriers, mass texting is not supported in LionDesk.</p>`,
  '<p>Be sure to review this <a href="https://lonewolf.my.site.com/s/article/LD-What-is-SMS-consent-and-how-do-I-obtain-it-LionDesk">guide to texting compliance</a> to maintain your good reputation with your contacts and the mobile carriers.</p>',
  '<p>You can check your texting limits and suite status at any time under the <a href="/communications/text/text-management" target="_blank">Text Management</a> console in LionDesk.</p>',
  '<p>Happy texting!</p>'
];

const CAMPAIGN_COMPLETED_BULK_TEXTS_CONTENT = [
  '<p><strong>Congratulations! Your registration was successful!</strong></p>',
  '<p>You are now able to use the power of texting in LionDesk for 1-to-1 communications and Text2Sell!</p>',
  '<p>Be sure to review this <a href="https://lonewolf.my.site.com/s/article/LD-What-is-SMS-consent-and-how-do-I-obtain-it-LionDesk">guide to texting compliance</a> to maintain your good reputation with your contacts and the mobile carriers.</p>',
  '<p>You can check your texting limits and suite status at any time under the <a href="/communications/text/text-management" target="_blank">Text Management</a> console in LionDesk.</p>',
  '<p>Happy texting!</p>'
];

const ERROR_CASE_30903_CONTENT = [
  '<p><strong>Your registration cannot be processed.</strong></p>',
  '<p>Your submission was rejected because you have an active business tax ID and you cannot register as a sole proprietor. Your current registration is ineligible for resubmission. Please contact support to reset your registration.</p>',
  '<p>NOTE: New registration fees may be incurred.</p>'
];

const DEFAULT_ERROR_CONTENT = [
  '<p><strong>Your registration cannot be processed.</strong></p>',
  '<p>Your submission was rejected due to a disallowed use case or content violation. Your registration is ineligible for resubmission.</p>',
];

const ERROR_CASE_30903_CONSOLE_CONTENT = {
  errorMessage: '<strong>Your Sole Proprietor registration was not accepted by US mobile carriers.</strong> Your submission was rejected because you have an active business tax ID and you cannot register as a sole proprietor. Your current registration is ineligible for resubmission.&nbsp;',
  afterSupportMessage: 'to reset your registration. NOTE: New registration fees may be incurred',
}

export const REGISTRATION_STATES = {
  DATA_REGISTRATION_SAVED: 'data_registration_saved',
  PAYMENT_PENDING: 'payment_pending',
  PAYMENT_RECEIVED: 'payment_received',
  PAYMENT_FAILED: 'payment_failed',
  CUSTOMER_PROFILE_COMPLETED: 'customer_profile_completed',
  CUSTOMER_PROFILE_FAILED: 'customer_profile_failed',
  A2P_BUNDLE_COMPLETED: 'a2p_bundle_completed',
  A2P_BUNDLE_FAILED: 'a2p_bundle_failed',
  BRAND_SUBMITTED: 'brand_submitted',
  BRAND_FAILED: 'brand_failed',
  BRAND_BLOCKED_FAILED: 'brand_blocked_failed',
  BRAND_BLOCKED_TCR_FAILED: 'brand_blocked_tcr_failed',
  BRAND_COMPLETED: 'brand_completed',
  BRAND_OTP_PENDING: 'brand_otp_pending',
  BRAND_OTP_FAILED: 'brand_otp_failed',
  BRAND_OTP_COMPLETED: 'brand_otp_completed',
  CAMPAIGN_SUBMITTED: 'campaign_submitted',
  CAMPAIGN_COMPLETED: 'campaign_completed',
  CAMPAIGN_COMPLETED_BULK_TEXTS: 'campaign_completed_bulk_texts',
  CAMPAIGN_FAILED: 'campaign_failed',
  BRAND_PENDING: 'brand_pending',
  A2P_BUNDLE_PENDING: 'a2p_bundle_pending',
  CUSTOMER_PROFILE_PENDING: 'customer_profile_pending',
  CAMPAIGN_PENDING: 'campaign_pending',
  CUSTOMER_PROFILE_ERROR: 'customer_profile_error',
  A2P_BUNDLE_ERROR: 'a2p_bundle_error',
  BRAND_ERROR: 'brand_error',
  CAMPAIGN_ERROR: 'campaign_error',
  BRAND_OTP_ERROR: 'brand_otp_error',
  CAMPAIGN_TWILIO_FAILED: 'campaign_twilio_failed',
  CAMPAIGN_TCR_FAILED: 'campaign_tcr_failed',
  CAMPAIGN_BLOCKED_FAILED: 'campaign_blocked_failed',
  CAMPAIGN_BLOCKED_TCR_FAILED: 'campaign_blocked_tcr_failed',
  BRAND_FAILED_3_TIMES: 'brand_failed_3_times',
  CAMPAIGN_FAILED_3_TIMES: 'campaign_failed_3_times',
  CAMPAIGN_PAYMENT_RETRY_RECEIVED: 'campaign_payment_retry_received',
  PAYMENT_CAMPAIGN_RETRY_PENDING: 'payment_campaign_retry_pending',
  BRAND_TCR_FAILED: 'brand_tcr_failed',
  BRAND_TCR_FAILED_RETRY_1: 'brand_tcr_failed_retry_1',
  BRAND_TCR_FAILED_RETRY_2: 'brand_tcr_failed_retry_2',
  BRAND_TCR_FAILED_RETRY_3: 'brand_tcr_failed_retry_3',
  BRAND_TCR_FAILED_STANDARD_RETRY_1: 'brand_tcr_failed_standard_retry_1',
  BRAND_TCR_FAILED_STANDARD_RETRY_2: 'brand_tcr_failed_standard_retry_2',
  BRAND_TCR_FAILED_RESTART: 'brand_tcr_failed_restart',
  PAYMENT_BRAND_RETRY_PENDING: 'payment_brand_retry_pending',
  PAYMENT_BRAND_RETRY_RECEIVED: 'payment_brand_retry_received',
  DEFAULT_ERROR: 'default_error',
  ERROR_CASE_30903: 30903,
}

export const ACTION_CODES = {
  GET_SUPPORT_ASSISTANCE: 'GET_SUPPORT_ASSISTANCE',
  FIX_IDENTITY_VERIFICATION: 'FIX_IDENTITY_VERIFICATION',
  START_REGISTRATION_AGAIN: 'START_REGISTRATION_AGAIN',
  FIX_TEXT_MESSAGE_TYPES: 'FIX_TEXT_MESSAGE_TYPES',
  REQUEST_EVALUATION_SUPPORT: 'REQUEST_EVALUATION_SUPPORT',
  REQUEST_RESETTING_SUPPORT: 'REQUEST_RESETTING_SUPPORT',
}

export const ACTION_LABELS = {
  GET_SUPPORT_ASSISTANCE: 'Get support assistance',
  FIX_IDENTITY_VERIFICATION: 'Fix Identity Verification',
  FIX_IDENTITY_VERIFICATION_RETRY_1: 'Fix Identity Verification - First Retry',
  FIX_IDENTITY_VERIFICATION_RETRY_2: 'Fix Identity Verification - Second Retry',
  FIX_IDENTITY_VERIFICATION_RETRY_FINAL: 'Fix Identity Verification - Final Retry',
  FIX_IDENTITY_VERIFICATION_RETRY_RESTART: 'Fix Identity Verification (Requires a restart fee)',
  START_REGISTRATION_AGAIN: 'Start registration again',
  FIX_TEXT_MESSAGE_TYPES: 'Fix message types',
  REQUEST_EVALUATION_SUPPORT: 'Request an evaluation from Support',
  REQUEST_RESETTING_SUPPORT: 'Request a reset from Support',
}
export const ACTION_WARNINGS = {
  BRAND_RETRY_ATTEMPTS_WARNING: '<strong>NOTE:</strong> You are allowed to retry your submission a total of 3 times before a new identity registration fee is incurred',
  BRAND_RETRY_STANDARD_ATTEMPTS_WARNING: '<strong>NOTE:</strong> You are allowed to retry your submission a total of 2 times before a new identity registration fee is incurred',
  BRAND_RETRY_RESTART_WARNING: '<strong>NOTE:</strong> US mobile carriers will charge you a verification restart fee due to multiple submission attempts.',
}

const SUPPORT_MAIL_CASE_30903 = {
  subject: 'Texting: Sole Proprietor registration blocked by EIN - need reset',
  body: 'My Sole Proprietor registration was blocked because the US carriers discovered that I have an active business tax ID. My texting registration needs to be reset so I can start a new one. I understand that additional fees might be incurred',
};

export const REGISTRATION_STATUSES_TEMPLATES = {
  [REGISTRATION_STATES.DATA_REGISTRATION_SAVED]: {
    icon: '$vuetify.icons.processing-status',
    content: BRAND_SUBMITTED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.PAYMENT_PENDING]: {
    icon: '$vuetify.icons.processing-status',
    content: BRAND_SUBMITTED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.PAYMENT_FAILED]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.PAYMENT_RECEIVED]: {
    icon: '$vuetify.icons.processing-status',
    content: BRAND_SUBMITTED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.BRAND_PENDING]: {
    icon: '$vuetify.icons.processing-status',
    content: BRAND_SUBMITTED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.BRAND_SUBMITTED]: {
    icon: '$vuetify.icons.processing-status',
    content: BRAND_SUBMITTED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.CUSTOMER_PROFILE_PENDING]: {
    icon: '$vuetify.icons.processing-status',
    content: BRAND_SUBMITTED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.CUSTOMER_PROFILE_COMPLETED]: {
    icon: '$vuetify.icons.processing-status',
    content: BRAND_SUBMITTED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.A2P_BUNDLE_PENDING]: {
    icon: '$vuetify.icons.processing-status',
    content: BRAND_SUBMITTED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.A2P_BUNDLE_COMPLETED]: {
    icon: '$vuetify.icons.processing-status',
    content: BRAND_SUBMITTED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.CUSTOMER_PROFILE_ERROR]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_ERROR_CONTENT,
    buttonLabel: ACTION_LABELS.GET_SUPPORT_ASSISTANCE,
    actionCode: ACTION_CODES.GET_SUPPORT_ASSISTANCE,
  },
  [REGISTRATION_STATES.A2P_BUNDLE_ERROR]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_ERROR_CONTENT,
    buttonLabel: ACTION_LABELS.GET_SUPPORT_ASSISTANCE,
    actionCode: ACTION_CODES.GET_SUPPORT_ASSISTANCE,
  },
  [REGISTRATION_STATES.BRAND_ERROR]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_ERROR_CONTENT,
    buttonLabel: ACTION_LABELS.GET_SUPPORT_ASSISTANCE,
    actionCode: ACTION_CODES.GET_SUPPORT_ASSISTANCE,
  },
  [REGISTRATION_STATES.CUSTOMER_PROFILE_FAILED]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_IDENTITY_VERIFICATION,
    actionCode: ACTION_CODES.FIX_IDENTITY_VERIFICATION,
  },
  [REGISTRATION_STATES.A2P_BUNDLE_FAILED]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_IDENTITY_VERIFICATION,
    actionCode: ACTION_CODES.FIX_IDENTITY_VERIFICATION,
  },
  [REGISTRATION_STATES.BRAND_FAILED]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_IDENTITY_VERIFICATION,
    actionCode: ACTION_CODES.FIX_IDENTITY_VERIFICATION,
  },
  [REGISTRATION_STATES.BRAND_FAILED_3_TIMES]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_3_TIMES_CONTENT,
    buttonLabel: ACTION_LABELS.GET_SUPPORT_ASSISTANCE,
    actionCode: ACTION_CODES.GET_SUPPORT_ASSISTANCE,
  },
  [REGISTRATION_STATES.CAMPAIGN_FAILED_3_TIMES]: {
    icon: '$vuetify.icons.failed-status',
    content: CAMPAIGN_FAILED_3_TIMES_CONTENT,
    buttonLabel: ACTION_LABELS.GET_SUPPORT_ASSISTANCE,
    actionCode: ACTION_CODES.GET_SUPPORT_ASSISTANCE,
  },
  [REGISTRATION_STATES.BRAND_COMPLETED]: {
    icon: '$vuetify.icons.accepted-status',
    content: BRAND_ACCEPTED_OTP_PENDING_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.BRAND_OTP_PENDING]: {
    icon: '$vuetify.icons.accepted-status',
    content: BRAND_ACCEPTED_OTP_PENDING_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.BRAND_OTP_ERROR]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_OTP_ERROR_CONTENT,
    buttonLabel: ACTION_LABELS.GET_SUPPORT_ASSISTANCE,
    actionCode: ACTION_CODES.GET_SUPPORT_ASSISTANCE,
  },
  [REGISTRATION_STATES.BRAND_OTP_FAILED]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_OTP_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.START_REGISTRATION_AGAIN,
    actionCode: ACTION_CODES.START_REGISTRATION_AGAIN,
  },
  [REGISTRATION_STATES.BRAND_OTP_COMPLETED]: {
    icon: '$vuetify.icons.successful-status',
    content: BRAND_OTP_COMPLETED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.CAMPAIGN_SUBMITTED]: {
    icon: '$vuetify.icons.verified-status',
    content: BRAND_OTP_COMPLETED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.CAMPAIGN_PENDING]: {
    icon: '$vuetify.icons.verified-status',
    content: BRAND_OTP_COMPLETED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.CAMPAIGN_PAYMENT_RETRY_RECEIVED]: {
    icon: '$vuetify.icons.verified-status',
    content: BRAND_OTP_COMPLETED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.CAMPAIGN_ERROR]: {
    icon: '$vuetify.icons.failed-status',
    content: CAMPAIGN_ERROR_CONTENT,
    buttonLabel: ACTION_LABELS.GET_SUPPORT_ASSISTANCE,
    actionCode: ACTION_CODES.GET_SUPPORT_ASSISTANCE,
  },
  [REGISTRATION_STATES.CAMPAIGN_TWILIO_FAILED]: {
    icon: '$vuetify.icons.failed-status',
    content: CAMPAIGN_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_TEXT_MESSAGE_TYPES,
    actionCode: ACTION_CODES.FIX_TEXT_MESSAGE_TYPES,
  },
  [REGISTRATION_STATES.CAMPAIGN_TCR_FAILED]: {
    icon: '$vuetify.icons.failed-status',
    content: CAMPAIGN_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_TEXT_MESSAGE_TYPES,
    actionCode: ACTION_CODES.FIX_TEXT_MESSAGE_TYPES,
  },
  [REGISTRATION_STATES.CAMPAIGN_BLOCKED_FAILED]: {
    icon: '$vuetify.icons.failed-status',
    content: CAMPAIGN_FAILED_BLOCKED_CONTENT,
    buttonLabel: ACTION_LABELS.REQUEST_EVALUATION_SUPPORT,
    actionCode: ACTION_CODES.REQUEST_EVALUATION_SUPPORT,
  },
  [REGISTRATION_STATES.CAMPAIGN_COMPLETED]: {
    icon: '$vuetify.icons.successful-status',
    content: CAMPAIGN_COMPLETED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.CAMPAIGN_COMPLETED_BULK_TEXTS]: {
    icon: '$vuetify.icons.successful-status',
    content: CAMPAIGN_COMPLETED_BULK_TEXTS_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.PAYMENT_CAMPAIGN_RETRY_PENDING]: {
    icon: '$vuetify.icons.verified-status',
    content: BRAND_OTP_COMPLETED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.BRAND_TCR_FAILED]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_IDENTITY_VERIFICATION,
    actionCode: ACTION_CODES.FIX_IDENTITY_VERIFICATION,
  },
  [REGISTRATION_STATES.BRAND_TCR_FAILED_RETRY_1]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_IDENTITY_VERIFICATION_RETRY_1,
    actionCode: ACTION_CODES.FIX_IDENTITY_VERIFICATION,
    actionWarning: ACTION_WARNINGS.BRAND_RETRY_ATTEMPTS_WARNING,
  },
  [REGISTRATION_STATES.BRAND_TCR_FAILED_RETRY_2]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_IDENTITY_VERIFICATION_RETRY_2,
    actionCode: ACTION_CODES.FIX_IDENTITY_VERIFICATION,
    actionWarning: ACTION_WARNINGS.BRAND_RETRY_ATTEMPTS_WARNING,
  },
  [REGISTRATION_STATES.BRAND_TCR_FAILED_RETRY_3]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_IDENTITY_VERIFICATION_RETRY_FINAL,
    actionCode: ACTION_CODES.FIX_IDENTITY_VERIFICATION,
    actionWarning: ACTION_WARNINGS.BRAND_RETRY_ATTEMPTS_WARNING,
  },
  [REGISTRATION_STATES.BRAND_TCR_FAILED_STANDARD_RETRY_1]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_IDENTITY_VERIFICATION_RETRY_1,
    actionCode: ACTION_CODES.FIX_IDENTITY_VERIFICATION,
    actionWarning: ACTION_WARNINGS.BRAND_RETRY_STANDARD_ATTEMPTS_WARNING,
  },
  [REGISTRATION_STATES.BRAND_TCR_FAILED_STANDARD_RETRY_2]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_IDENTITY_VERIFICATION_RETRY_FINAL,
    actionCode: ACTION_CODES.FIX_IDENTITY_VERIFICATION,
    actionWarning: ACTION_WARNINGS.BRAND_RETRY_STANDARD_ATTEMPTS_WARNING,
  },
  [REGISTRATION_STATES.BRAND_TCR_FAILED_RESTART]: {
    icon: '$vuetify.icons.failed-status',
    content: BRAND_FAILED_CONTENT,
    buttonLabel: ACTION_LABELS.FIX_IDENTITY_VERIFICATION_RETRY_RESTART,
    actionCode: ACTION_CODES.FIX_IDENTITY_VERIFICATION,
    actionWarning: ACTION_WARNINGS.BRAND_RETRY_RESTART_WARNING,
  },
  [REGISTRATION_STATES.PAYMENT_BRAND_RETRY_PENDING]: {
    icon: '$vuetify.icons.verified-status',
    content: BRAND_SUBMITTED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.PAYMENT_BRAND_RETRY_RECEIVED]: {
    icon: '$vuetify.icons.verified-status',
    content: BRAND_SUBMITTED_CONTENT,
    buttonLabel: '',
    actionCode: '',
  },
  [REGISTRATION_STATES.DEFAULT_ERROR]: {
    icon: '$vuetify.icons.failed-status',
    content: DEFAULT_ERROR_CONTENT,
    buttonLabel: ACTION_LABELS.REQUEST_EVALUATION_SUPPORT,
    actionCode: ACTION_CODES.REQUEST_EVALUATION_SUPPORT,
  },
  [REGISTRATION_STATES.ERROR_CASE_30903]: {
    icon: '$vuetify.icons.failed-status',
    content: ERROR_CASE_30903_CONTENT,
    buttonLabel: ACTION_LABELS.REQUEST_RESETTING_SUPPORT,
    actionCode: ACTION_CODES.REQUEST_RESETTING_SUPPORT,
    errorCase: REGISTRATION_STATES.ERROR_CASE_30903,
    supportMail: SUPPORT_MAIL_CASE_30903,
    consoleContent: ERROR_CASE_30903_CONSOLE_CONTENT,
  },
};
